module.exports = __webpack_public_path__ + "img/WOORIBANK.fcd7c877.svg";